const img = document.querySelectorAll('.rand-image')

if (img) {
  ;[...img].map((el) => {
    const urls = JSON.parse(el.getAttribute('data-images'))
    const url = urls[Math.floor(Math.random() * urls.length)]
    el.src = url
    if (el.complete) {
      el.style.visibility = 'visible'
    } else {
      el.addEventListener('load', () => (el.style.visibility = 'visible'))
    }
  })
}
